export default __webpack_public_path__ + "static/media/image.20422398.jpg";